import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(menuAnatomy.keys);

export const menuTheme = defineMultiStyleConfig({
	baseStyle: definePartsStyle({
		item: {
			px: 4,
			py: 2.5,
		},
		list: {
			border: "none", // This is required as a bandaid fix for Courses microfrontend overriding this due to it still using the old FZCL Chakra theme
		},
	}),
});
